"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureToggle = exports.getUrlOrigin = exports.getCustomConfig = void 0;
const getCustomConfig = (serviceConfig) => {
    if (serviceConfig && serviceConfig.customConfig) {
        return serviceConfig.customConfig;
    }
    else {
        return {};
    }
};
exports.getCustomConfig = getCustomConfig;
const getUrlOrigin = (serviceConfig) => {
    return serviceConfig ? serviceConfig.urlOrigin : '';
};
exports.getUrlOrigin = getUrlOrigin;
const getFeatureToggle = (serviceConfig, toggleName) => {
    return !!(0, exports.getCustomConfig)(serviceConfig)[toggleName];
};
exports.getFeatureToggle = getFeatureToggle;
//# sourceMappingURL=ServiceConfigHelper.js.map